import { render } from "./WebhookDeliveriesTab.vue?vue&type=template&id=b064f55e&scoped=true"
import script from "./WebhookDeliveriesTab.vue?vue&type=script&lang=js"
export * from "./WebhookDeliveriesTab.vue?vue&type=script&lang=js"

import "./WebhookDeliveriesTab.vue?vue&type=style&index=0&id=b064f55e&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b064f55e"]])

export default __exports__